import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PetitionCTA } from "@/components/PetitionCTA";

export const MobileStickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.33, 1, 0.68, 1] }}
          data-testid="mobile-sticky-cta"
          className="fixed inset-x-0 bottom-0 z-50 border-t border-gooi-green/10 bg-gooi-offwhite/90 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl md:hidden"
        >
          <PetitionCTA location="sticky_mobile" size="md" className="w-full" />
          <p className="mt-1.5 text-center text-xs font-medium text-gooi-green/60">
            Samen voor 80 km/u — iedere handtekening telt
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
